import type { SVGProps } from "react";
const SenecPictogramStability = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M31.7071 13.7071C32.0976 13.3166 32.0976 12.6834 31.7071 12.2929C31.3166 11.9024 30.6834 11.9024 30.2929 12.2929L23 19.5858L19.7071 16.2929C19.3166 15.9024 18.6834 15.9024 18.2929 16.2929C17.9024 16.6834 17.9024 17.3166 18.2929 17.7071L23 22.4142L31.7071 13.7071Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 17C9 8.71573 15.7157 2 24 2C32.2843 2 39 8.71573 39 17C39 21.9075 36.6433 26.2645 33 29.0011V45C33 45.3924 32.7705 45.7485 32.4132 45.9106C32.0559 46.0728 31.6368 46.011 31.3415 45.7526L24.0456 39.3686L17.7071 45.7071C17.4211 45.9931 16.991 46.0787 16.6173 45.9239C16.2436 45.7691 16 45.4045 16 45V35C16 34.4477 16.4477 34 17 34C17.5523 34 18 34.4477 18 35V42.5858L23.9544 36.6314L31 42.7962V30.2699C28.9103 31.3745 26.5282 32 24 32C15.7157 32 9 25.2843 9 17ZM24 4C16.8203 4 11 9.8203 11 17C11 24.1797 16.8203 30 24 30C31.1797 30 37 24.1797 37 17C37 9.8203 31.1797 4 24 4Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramStability;
